import { useState } from "react";
import CreateIssue from "../CreateIssue/CreateIssue";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { useTranslation } from "@i18n";
// import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import Text from "@CubeComponents/html/Text/Text";
import SelectSpaces from "@Components/WorkspaceList/SelectSpaces";
import { defaultModulesMapper } from "@Helpers/constants";

interface CreateIssueModalProps {
  extraParametersOnIssueCreation?: Record<string, unknown>;
  closeModal: () => void;
  refreshDataGrid?: () => void;
  projectId: string;
  attachedReviewId?: string | null;
  defaultSpaceId?: string | null;
}

function CreateIssueModal({
  extraParametersOnIssueCreation = {},
  closeModal,
  refreshDataGrid,
  projectId,
  attachedReviewId,
  defaultSpaceId = null,
}: Readonly<CreateIssueModalProps>) {
  const { t } = useTranslation();
  const [spaceId, setSpaceId] = useState(defaultSpaceId);

  const headerContent = () => (
    <div className="w-full flex justify-between rounded-md items-center px-6 py-4">
      <Text>{t("Create Issue")}</Text>
    </div>
  );

  const getSpacesDropdown = () => (
    <SelectSpaces
      moduleName={defaultModulesMapper.ISSUES}
      data-testid="spaceDropdownField"
      allowBorder={true}
      projectId={projectId}
      selectedSpaceCallback={(params: { _id: string }) => {
        setSpaceId(params._id);
      }}
    />
  );

  const modelContent = () => (
    <div className="flex flex-col pt-6 pb-3">
      <div className="flex gap-2 px-6 bg-white items-center">
        <Text>{t("Select space:")}</Text>
        {getSpacesDropdown()}
      </div>
      <div className="h-600">
        <CreateIssue
          extraParametersOnIssueCreation={extraParametersOnIssueCreation}
          isStandalone
          onCancel={closeModal}
          workspaceId={spaceId}
          refreshDataGrid={refreshDataGrid}
          attachedReviewId={attachedReviewId}
        />
      </div>
    </div>
  );

  return (
    <ModalStateDialogComponent
      isVisible
      onCancel={closeModal}
      allowModalPadding={false}
      width="70%"
      headerTitle={headerContent()}
      modelContent={modelContent()}
      modalPadding={0}
    />
  );
}

export default CreateIssueModal;
